// extracted by mini-css-extract-plugin
export var subtitle = "_8c-2";
export var title = "_8c-0";
export var titleNoWrap = "_8c-1";